import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface showReciptVoucher {
    voucher_no?: string;
    date?: string;
    client?: { type: 'client', data: { id: number; name: string; } };
    order?: { type: 'order', data: { id: number; order_no: string; } };
    amount?: number;
    statement?: string;
}

// Show recipt voucher state
export interface showReciptVoucherState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showReciptVoucher;
}

const initialShowReciptVoucherState: showReciptVoucherState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {}
}

// Show recipt voucher slice
export const showReciptVoucherSlice = createSlice({
    name: 'show_recipt_voucher',
    initialState: initialShowReciptVoucherState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setData: ( state, {payload}: PayloadAction<showReciptVoucher> ) => {
            state.data = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<{ id: number, isOpen: boolean }> ) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
        }
    }
})